/* mf-face.js — the gender lens's two DOM chores.
 *
 * The lens itself is not here. It is one CSS rule in the head of layout/theme.liquid
 * keyed on the html.mf-g-women / html.mf-g-men class that the pre-paint script stamps,
 * hiding .dcard[data-g="m"] and .dcard[data-g="w"] respectively. That is deliberately
 * all it is: the server sends one document to every visitor, nothing is personalised
 * behind a shared URL, and a card that does not belong to the face is never painted
 * once — no flash, no layout shift, and crawlers keep seeing the full catalogue.
 *
 * What CSS cannot do is the two things below.
 *
 * 1. THE HEADER OVERLAY'S "POPULAR CASES" ROW is sliced server-side by Liquid's
 *    `limit`, which runs before anything can be hidden. The snippet now asks for 8
 *    and this caps the row back to the first four the visitor can actually see.
 *
 * 2. THE THIN FACE. Some collections are curated one way round: /collections/cute is
 *    97% FOR HER, so the men's face lands on almost nothing. The auto-fill in
 *    collection-v2 tops the grid up, then gives up. When it does, say so and offer the
 *    way out, rather than leaving a short grid with no explanation. The step is fired
 *    once per pageview so the merchant can see which collections need the opt-out
 *    (collection-v2's face_lens_blacklist) or a tagging pass.
 *
 * Nothing here rewrites a link, touches the URL, or writes storage.
 */
(function () {
  'use strict';

  var W = window, D = document;
  if (W.Shopify && W.Shopify.designMode) { return; }

  function face() { return (W.__mfFace ? W.__mfFace() : '') || ''; }
  function shows(el) { return !W.__mfGShow || W.__mfGShow(el); }
  function step(name) {
    try { if (W.mfTrackPush) { W.mfTrackPush('mf_nav_step', { mf_step: name }); } } catch (e) {}
  }

  /* ── 1. the overlay's popular row ─────────────────────────────────────────── */
  function capPopular() {
    var grid = D.querySelector('.glossy-search__grid');
    if (!grid) { return; }
    var kept = 0;
    [].forEach.call(grid.querySelectorAll('.dcard'), function (card) {
      if (!shows(card)) { return; }               /* the CSS rule already hid it */
      kept++;
      card.hidden = kept > 4;
    });
  }

  /* the overlay is populated and repopulated by glossy-search-block's own script;
     watch the grid rather than guessing at its open event */
  function watchPopular() {
    var grid = D.querySelector('.glossy-search__grid');
    if (!grid || !W.MutationObserver) { return; }
    var pending = false;
    new MutationObserver(function () {
      if (pending) { return; }
      pending = true;
      setTimeout(function () { pending = false; capPopular(); }, 40);
    }).observe(grid, { childList: true });
  }

  /* ── 2. the thin-face escape strip ────────────────────────────────────────── */
  /* 8 is the floor for an unfiltered grid. With a mood chip on it has to be higher:
     the measured worst realistic case, Cute on the men's face of iPhone 17 Pro Max, is
     nine products - it would slip under an 8 and the visitor would get a nine-card page
     with no explanation. Read from the URL each time, because the sidebar path changes
     the query string without a reload. */
  function thinFloor() {
    return /[?&]filter\.p\.tag=/.test(W.location.search) ? 12 : 8;
  }
  var stripDone = false, thinSteps = 0;

  function gridOf() {
    return D.querySelector('#search-product-list .product-list__inner') ||
           D.querySelector('[id^="collection-grid-"] .product-list__inner');
  }

  function visibleCount(inner) {
    return [].filter.call(inner.querySelectorAll('.dcard'), shows).length;
  }

  function surface() {
    return D.querySelector('#search-product-list') ? 'srch' : 'plp';
  }

  function buildStrip(inner) {
    if (stripDone) { return; }
    stripDone = true;

    var bar = D.createElement('div');
    bar.className = 'mf-thin';
    bar.setAttribute('role', 'status');

    var txt = D.createElement('span');
    txt.className = 'mf-thin__txt';
    txt.textContent = 'Kevés minta van ehhez a szűréshez.';

    var btn = D.createElement('button');
    btn.type = 'button';
    btn.className = 'mf-thin__cta';
    btn.textContent = 'Összes megtekintése →';
    btn.addEventListener('click', function () {
      step('mnu:g_off');
      /* review C12: the drawer tab emits the same mnu:g_off - this one is the strip's */
      step('mnu:g_offstrip');
      if (W.__mfSetFace) { W.__mfSetFace(''); }
      W.location.reload();
    });

    var x = D.createElement('button');
    x.type = 'button';
    x.className = 'mf-thin__x';
    x.setAttribute('aria-label', 'Bezárás');
    x.innerHTML = '&#10005;';
    x.addEventListener('click', function () { bar.parentNode && bar.parentNode.removeChild(bar); });

    bar.appendChild(txt);
    bar.appendChild(btn);
    bar.appendChild(x);
    inner.parentNode.insertBefore(bar, inner);
  }

  function checkThin() {
    if (!face() || stripDone) { return; }
    var inner = gridOf();
    if (!inner) { return; }
    if (visibleCount(inner) >= thinFloor()) { return; }
    if (thinSteps < 3) { thinSteps++; step(surface() + ':g_thin'); }
    buildStrip(inner);
  }

  var thinObserver = null;
  function watchThin() {
    if (!face()) { return; }
    var inner = gridOf();
    if (!inner) { return; }
    if (thinObserver) { thinObserver.disconnect(); thinObserver = null; }
    /* 2.5 s is past collection-v2's auto-fill first tick (600 ms) and its retries;
       the mutation watcher covers a slow one, and both paths are latched */
    setTimeout(checkThin, 2500);
    if (!W.MutationObserver) { return; }
    var pending = false;
    thinObserver = new MutationObserver(function () {
      if (stripDone) { return; }
      if (pending) { return; }
      pending = true;
      setTimeout(function () { pending = false; checkThin(); }, 600);
    });
    thinObserver.observe(inner, { childList: true });
  }

  /* The filter sidebar replaces #facet-main's innerHTML wholesale (theme.js), which
     DETACHES the node this observer was watching - the watcher goes silent on exactly
     the interaction that produces the thinnest grids. Re-arm on a fresh node, and let
     the strip appear again for the new result set. */
  D.addEventListener('facet:criteria-changed', function () {
    setTimeout(function () {
      var old = D.querySelector('.mf-thin');
      if (old && old.parentNode) { old.parentNode.removeChild(old); }
      stripDone = false;
      watchThin();
      setTimeout(checkThin, 1200);
    }, 300);
  });

  function boot() {
    capPopular();
    watchPopular();
    watchThin();
  }

  if (D.readyState === 'loading') { D.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
